import type { ReviewsForStorefront } from '@api/graphql/reviews/getReviewsForStorefront';
import type { ReviewsResponseData } from 'types/api/reviews';
import { mapReviews } from '../reviewsForVendor/mapper';

export const mapReviewsForStorefront = (
	storefrontId: string,
	data: ReviewsForStorefront,
	page: number,
	size: number,
): ReviewsResponseData => {
	return {
		data: mapReviews(data.reviews.nodes, storefrontId),
		resultsCount: data.reviews.nodes.length,
		totalCount: data.reviews.totalCount,
		page,
		pageSize: size,
		gallery: [],
	};
};
